<app-password caption="-o-" section="datafield" [validate]="false" [value]="passwordComponentValue()" [allowShowPassword]="allowShowPassword()" [disabled]="effectiveDisabled()"
  (valueChange)="valueChange($event)">
</app-password>
